// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background-image[data-v-031cc94e]{position:absolute;z-index:1!important;background-repeat:repeat;background-size:auto;top:clamp(1rem,2vw,2rem);right:clamp(1rem,2vw,2rem);bottom:calc(clamp(1rem,2vw,2rem)*-1);left:calc(clamp(1rem,2vw,2rem)*-1)}.background-image.inverted[data-v-031cc94e]{right:calc(clamp(1rem,2vw,2rem)*-1);left:clamp(1rem,2vw,2rem)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
